import { generatedTemplateCommande, generatedErrorCommandeFile } from '@/services/importClient/commande/templateCommande';
import { makeCommandeGenerated, makeCommandeImport } from '@/services/importClient/commande/makeCommandeImport';

export const TYPE_COMMANDE = 'Commande';

export const IMPORT_DATA_TYPE = [
  {
    type: TYPE_COMMANDE,
    title: 'importDonneIdelia.commande.title',
    description: 'importDonneIdelia.commande.description',
    template: generatedTemplateCommande,
    generate: makeCommandeGenerated,
    importHandler: makeCommandeImport,
    importErrorHandler: generatedErrorCommandeFile,
    generateErrorHandler: () => ({}),
    renderAnErrorFile: true,
    isUserImport: true,
    hasTest: true,
  },
];
